import {
  Images as AboutUsImageGalleryProps,
  StoryblokImage,
  storyblokEditable,
} from '@cinch-nx/data-storyblok'
import cx from 'classnames'
import Image from 'next/legacy/image'

import styles from './image-gallery.module.css'

export const ImageGallery: React.FC<AboutUsImageGalleryProps> = (blok) => {
  const { images } = blok

  return (
    <section {...storyblokEditable(blok)} className={styles.galleryGrid}>
      {images
        ?.filter((image: StoryblokImage) => image?.filename)
        ?.map((image: StoryblokImage, idx: number) => (
          <div
            key={image.id}
            className={cx(styles.imageWrapper, styles[`image${idx + 1}`], {
              [styles.mobileMargins]: idx <= 1,
              [styles.mobileImage]: idx <= 2,
              [styles.desktopImage]: idx > 2,
            })}
          >
            <Image
              src={image.filename}
              alt={image.alt ?? undefined}
              layout="fill"
              objectPosition="60% center"
              objectFit="cover"
            />
          </div>
        ))}
    </section>
  )
}

export default ImageGallery
